import { lotteryAbi } from '@/abi/lotteryAbi'
import { TransactionStatus } from '@/types/web3/transactions'
import retry from '@/utilities/retry'
import { decodeErrorResult, Hash, PublicClient } from 'viem'

async function debugTransaction(publicClient: PublicClient, hash: Hash) {
    const tx = await publicClient.getTransaction({ hash })
    console.log('tx', tx)
    try {
        await publicClient.call({
            to: tx.to!,
            data: tx.input,
            value: tx.value,
            gas: tx.gas,
        })
        return null
    } catch (err: any) {
        console.log(err)
        const data = err?.cause?.data || err?.data
        if (!data) {
            throw new Error('No revert data found in error')
        }
        const decoded = decodeErrorResult({ abi: lotteryAbi, data })
        return decoded
    }
}

export default class TransactionManager {
    initialized: boolean = false
    updateHandler: (id: string, status: TransactionStatus, title: string) => void = () => { }
    publicClient: PublicClient | undefined

    initialize(publicClient: PublicClient, updateHandler: (id: string, status: TransactionStatus, title: string) => void) {
        this.updateHandler = updateHandler
        this.publicClient = publicClient
    }

    async trackTransaction(id: string, transaction: Promise<Hash>, title: string, statusSync: (status: TransactionStatus) => void) {
        if (!this.publicClient) { return }
        try {
            this.updateHandler(id, 'userPrompt', title)
            statusSync('userPrompt')

            const hash = await transaction
            this.updateHandler(id, 'pending', title)
            statusSync('pending')
            try {
                const publicClient = this.publicClient
                
                const receipt = await publicClient.waitForTransactionReceipt({ hash, confirmations: 1 })

                // TODO: Delete me
                if (receipt.status === 'reverted') {
                    const decoded = await debugTransaction(publicClient, hash)
                    console.log('decoded', decoded)
                }

                this.updateHandler(id, receipt.status, title)
                statusSync(receipt.status)
            } catch (error) {
                console.log('error', error)
                this.updateHandler(id, 'reverted', title)
                statusSync('reverted')
            }
        } catch {
            this.updateHandler(id, 'cancelled', title)
            statusSync('cancelled')
        }
    }
}